import { CreateProductInstructor, CreateSearchResult } from '../interfaces/create-search.interface';
import { HE } from '../../../../common/utils/util';
import { ProductCardData } from '../../../product-card/product-card-display';
import { getCreateImage } from '../utils/create-search.util';
import { getCreateProductUrl } from '../../utils/create-custom-product.util';
import { mapCreateProductFormat } from '../../mappings/create-custom.mapping';

/**
 * Maps Create search results to product card data.
 *
 * @param results
 */
export function mapCreateProductCardData(results: CreateSearchResult[]): ProductCardData[] {
  return results.map((result) => {
    return {
      kind: 'ProductCardData',
      title: result.document.name,
      image: getCreateImage(result.document),
      url: getCreateProductUrl(result.document.isbn13),
      copyRightYear: result.document.copyrightYear ? result.document.copyrightYear.toString() : '',
      businessUnit: HE,
      instructorOnly: false,
      productBusinessUnit: undefined,
      mhid: result.document.isbn10,
      isbn: result.document.isbn10,
      isbn13: result.document.isbn13,
      contributors: mapInstructors(result.document.instructors),
      description: result.document.description,
      gradeLevels: '',
      edition: result.document.edition,
      documentType: result.document.type,
      type: result.document.type,
      quantity: 1,
      netPrice: result.document.price,
      optimizedUniqueTitle: result.document.name,
      id: result.document.id,
      formatTypeDesc: mapCreateProductFormat(result.document.deliveryTypes || []),
      bundleDiscountedPrice: 0,
      isDiscountedBundle: false,
      offerType: result.document.productType?.toLowerCase(),
    };
  });
}

function mapInstructors(instructors?: CreateProductInstructor[]): string[] {
  if (!instructors?.length) {
    return [];
  }

  return instructors.map(({ displayName }) => displayName?.replace('null', '').trim() ?? '').filter(Boolean);
}
